import { render, staticRenderFns } from "./PalletLabelPopup.vue?vue&type=template&id=5036b1c2"
import script from "./PalletLabelPopup.vue?vue&type=script&lang=js"
export * from "./PalletLabelPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports